// extracted by mini-css-extract-plugin
export default {"outlinedToday":"PsychologistProfile_outlinedToday__7BUdc"};